import styled from "styled-components";

export const StripePaymentFormContainer = styled.div`

`